import { Box, IconButton } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { CustomTextField, CustomButton, HorizontalForm } from '../../../common';
import { calculateInterest } from '../utils/updateDebtUtils';

const DebtEditControls = ({
  secondExpirationDate,
  setSecondExpirationDate,
  selectedItem,
  payChecks,
  regularizeChecks,
  onModifiedCouponsChange,
  onPayChecksChange,
  onRegularizeChecksChange,
}) => {
  const handleSecondExpirationDateChange = () => {
    if (!secondExpirationDate || !selectedItem?.coupons) return;

    const updatedCoupons = selectedItem.coupons.map((coupon) => {
      const interest = calculateInterest(
        coupon.first_due_amount,
        coupon.first_due_date,
        secondExpirationDate
      );

      return {
        ...coupon,
        third_due_date: secondExpirationDate,
        interest: interest,
        third_due_amount: Math.round(coupon.first_due_amount + interest),
      };
    });

    onModifiedCouponsChange(updatedCoupons);
  };

  const handlePayAll = () => {
    const allChecked = payChecks.every((checked) => checked);
    onPayChecksChange(selectedItem.coupons.map(() => !allChecked));
    onRegularizeChecksChange(selectedItem.coupons.map(() => false));
  };

  const handleRegularizeAll = () => {
    const allChecked = regularizeChecks.every((checked) => checked);
    onRegularizeChecksChange(selectedItem.coupons.map(() => !allChecked));
    onPayChecksChange(selectedItem.coupons.map(() => false));
  };

  return (
    <HorizontalForm
      sx={{
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 2,
        py: 2,
        minHeight: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 4,
          flexWrap: 'wrap',
          mt: -2,
        }}
      >
        <CustomButton variant="warning" onClick={handlePayAll} size="small">
          Pagar todos
        </CustomButton>
        <CustomButton variant="warning" onClick={handleRegularizeAll} size="small">
          Regularizar todos
        </CustomButton>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          alignContent: 'center',
          gap: 1,
          marginBottom: 2
        }}
      >
        <CustomTextField
          label="Nueva fecha 3er vencimiento"
          type="date"
          size="medium"
          value={secondExpirationDate}
          onChange={(e) => setSecondExpirationDate(e.target.value)}
          sx={{ mt: 0, width: '200px' }}
          shrinkLabel={true}
        />
        <IconButton
          onClick={handleSecondExpirationDateChange}
          sx={{
            backgroundColor: 'primary.main',
            color: 'white',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      </Box>
    </HorizontalForm>
  );
};

export default DebtEditControls;
